import axios from 'axios';
import environmentConfig from '../config/environment-configs';

export const api = axios.create({
  baseURL: environmentConfig.API_BASE_URL,
  headers: {
    'Content-Type': '*/*',
    'Access-Control-Allow-Origin': '*',
    'Access-Control-Allow-Methods': '*',
  },
});

function getFileName(xhr: XMLHttpRequest) {
  const header = xhr.getResponseHeader('Content-Disposition');
  const filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
  const matches = filenameRegex.exec(header || '');
  const filename =
    matches != null && matches[1] ? matches[1].replace(/['"]/g, '') : '';

  return filename;
}

export function downloadGet(token: string, serviceId: string) {
  return new Promise((resolve, reject) => {
    const xhr = new XMLHttpRequest();
    const url = environmentConfig.API_BASE_URL;
    xhr.open('GET', `${url}/download-data-services/${serviceId}`, true);
    xhr.setRequestHeader('Content-type', 'application/zip');
    xhr.setRequestHeader('Authorization', `Bearer ${token}`);
    xhr.responseType = 'blob';

    xhr.onreadystatechange = () => {
      if (xhr.readyState === XMLHttpRequest.DONE && xhr.status === 200) {
        const body = xhr.response;
        const blob = new Blob([body], { type: 'application/zip' });
        const filename = getFileName(xhr);
        resolve({ blob, filename });
      }

      if (xhr.readyState === XMLHttpRequest.DONE && xhr.status !== 200) {
        reject();
      }
    };

    xhr.send('');
  });
}
